<div class="app-connector-item">
  <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem; flex-wrap: wrap;">
    <div class="connector">
      <img [src]="connector.icon" />
      <p>{{ connector.connectorType.name }}</p>
    </div>

    <div class="connector-top-actions" style="display: flex; align-items: center; gap: 4px;">
      <div *ngIf="showConnectorPaidInfo()">
        <!-- TODO: Dynamically show the icon, if the connector is paid -->
        <mat-icon class="text-green">attach_money</mat-icon>
        <mat-icon class="text-blue">credit_card</mat-icon>
      </div>
      <button
        *ngIf="isAuthenticated() && showRepairReport()"
        mat-icon-button
        matTooltip="Report a problem"
        aria-label="Report a problem"
        (click)="openReportFaultDialog()"
      >
        <mat-icon>report_problem</mat-icon>
      </button>
    </div>
  </div>

  <p class="network"><strong>Network:</strong> {{ charger.networks.name }}</p>
  <ul class="stats">
    <li *ngIf="connector.powerType">{{ connector.powerType }}</li>
    <li
      [style.color]="connector.status === 'BUSY' ? '#f87171' : ''"
      [style.backgroundColor]="connector.status === 'BUSY' ? '#fef2f2' : ''"
    >
      {{ connector?.status.split("_").join(" ") }}
    </li>
    <li *ngIf="connector.chargeKwh">{{ connector.chargeKwh }} kW</li>
    <li *ngIf="connector.chargeKwh >= 24">Rapid</li>
  </ul>

  <div class="connector-action-buttons" *ngIf="showConnectorButtons()">
    <button mat-flat-button [disabled]="isLoading()" (click)="startActivity('START')" *ngIf="buttonStatus().start">
      Start charging
    </button>
    <button mat-flat-button [disabled]="isLoading()" (click)="startActivity('WAIT')" *ngIf="buttonStatus().wait" class="wait-button">
      Waiting
    </button>
    <button mat-flat-button [disabled]="isLoading()" (click)="endActivity('START')" *ngIf="buttonStatus().endCharging" class="end-button">
      End
    </button>
    <button mat-flat-button [disabled]="isLoading()" (click)="endActivity('WAIT')" *ngIf="buttonStatus().endWaiting" class="end-button">
      End
    </button>
  </div>

  <div class="activity-list" *ngIf="activityList().waiting.length > 0">
    <div class="collapse-header" (click)="toggleWaitingList()">
      <h4>Waiting</h4>
      <button mat-icon-button>
        <mat-icon>
          {{ waitingListOpen() ? "expand_more" : "expand_less" }}
        </mat-icon>
      </button>
    </div>
    <div class="activities-list" [style.display]="waitingListOpen() ? 'block' : 'none'">
      <div
        class="activity-list-item"
        *ngFor="let item of activityList().waiting"
      >
        <div class="header">
          <div class="avatar">
            <mat-icon>person</mat-icon>
            <app-gc-image [src]="getAuthorPhoto?.(item.userId)" alt="" />
          </div>
          <div class="author">
            <span class="name">{{ item.user.displayName }}</span>
            <span class="vehicle">
              {{ getDefaultVehicle(item.user.userPreferences.vehicles)?.make }}
              {{ getDefaultVehicle(item.user.userPreferences.vehicles)?.model }}
            </span>
          </div>
        </div>

        <p class="note" *ngIf="item.notes">{{ item.notes }}</p>
      </div>
    </div>
  </div>

  <div class="activity-list" *ngIf="activityList().charging.length > 0">
    <div class="collapse-header" (click)="toggleChargingList()">
      <h4>Charging now</h4>
      <button mat-icon-button>
        <mat-icon>
          {{ chargingListOpen() ? "expand_more" : "expand_less" }}
        </mat-icon>
      </button>
    </div>
    <div class="activities-list" [style.display]="chargingListOpen() ? 'block' : 'none'">
      <div
        class="activity-list-item"
        *ngFor="let item of activityList().charging"
      >
        <div class="header">
          <div class="avatar">
            <mat-icon>person</mat-icon>
            <app-gc-image [src]="getAuthorPhoto?.(item.userId)" alt="" />
          </div>
          <div class="author">
            <span class="name">{{ item.user.displayName }}</span>
            <span class="vehicle">
              {{ getDefaultVehicle(item.user.userPreferences.vehicles)?.make }}
              {{ getDefaultVehicle(item.user.userPreferences.vehicles)?.model }}
            </span>
          </div>
        </div>

        <p class="note" *ngIf="item.notes">{{ item.notes }}</p>
      </div>
    </div>
  </div>
</div>
